import { Alert, Empty } from "antd";
import { useTranslation } from "react-i18next";
import { CustomButton, Loader } from "sipli-fleet-core/components";
import { useQueryDeviceDetails } from "src/queries/deviceDetails.queries";
import DeviceDetailsCard from "./DeviceDetailsCard";
import TechnicalInformationCard from "./TechnicalInformationCard";
import VehicleDetailsCard from "./VehicleDetailsCard";

const DeviceDetailsTab = ({ unitId }: { unitId?: string }) => {
  const { t } = useTranslation();
  const detailsQuery = useQueryDeviceDetails(unitId);

  if (!unitId) return <Alert type="error" showIcon message={t("invalid_unit_id")} />;
  if (detailsQuery.isLoading) {
    return <Loader height="h-[500px]" className="rounded-[16px] bg-white" />;
  }
  if (detailsQuery.isError) {
    return (
      <Alert
        type="error"
        showIcon
        message={t("device_details_load_failed")}
        action={
          // build test
          <CustomButton
            type="secondary"
            label={t("retry")}
            onClick={() => detailsQuery.refetch()}
          />
        }
      />
    );
  }

  const { device, vehicle, fuelSensors } = detailsQuery.data ?? {};
  if (!device && !vehicle)
    return (
      <div className="rounded-xl bg-white py-12">
        <Empty description={t("no_data")} />
      </div>
    );

  return (
    <div className="rounded-[16px] bg-white p-4 pb-6">
      <div className="mb-7">
        <h2 className="mb-1 text-xl font-bold text-black">{t("details")}</h2>
        <p className="m-0 text-sm text-gray10">{t("vehicle_device_details_description")}</p>
      </div>

      <div className="grid grid-cols-1 items-start gap-4 xl:grid-cols-2">
        {vehicle && <VehicleDetailsCard vehicle={vehicle} fuelSensors={fuelSensors} />}
        <div className="flex min-w-0 flex-col gap-4">
          {device && <DeviceDetailsCard device={device} />}
          {vehicle && <TechnicalInformationCard vehicle={vehicle} />}
        </div>
      </div>
    </div>
  );
};

export default DeviceDetailsTab;
